<script setup lang="ts">
import AppButton from '@/application/components/ui/AppButton.vue';

</script>

<template>
  <div class="flex grow bg-light">
    <div class="container flex flex-col grow items-center justify-center">
      <span class="text-xl md:text-2xl lg:text-3xl">
        Oops! Diese Seite gibt es nicht.
      </span>
      <div class="py-5 md:py-7 lg:py-10">
        <RouterLink
          v-slot="{ navigate }"
          to="/"
          custom
        >
          <AppButton
            type="primary"
            size="large"
            :handler="navigate"
          >
            Zur Startseite
          </AppButton>
        </RouterLink>
      </div>
    </div>
  </div>
</template>
